import { ref } from 'vue-demi';

const verifyMsg = ref('');

const verificaEmail = (email: string): boolean => {
  if (!email) {
    verifyMsg.value = '请输入邮箱';
    return false;
  } 

  // eslint-disable-next-line no-useless-escape
  const pattern = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/;
  if (!pattern.test(email)) {
    verifyMsg.value = '邮箱格式不正确';
    return false;
  }

  return true;
};

const verificaPassword = (password: string): boolean => {
  if (!password) {
    verifyMsg.value = '请输入密码';
    return false;
  }
  return true;
};

const confirmPassword = (password: string, comfirmPassword: string): boolean => {
  if (!comfirmPassword) {
    verifyMsg.value = '请输入确认密码';
    return false;
  }
  if (password !== comfirmPassword) {
    verifyMsg.value = '两次密码不一致';
    return false;
  }
  return true;
};

const verificaCode = (code: number | null): boolean => {
  console.log(code);
  console.log(typeof code);
  
  if (code === undefined || code === 0) {
    verifyMsg.value = '验证码不能为空';
    return false;
  }
  if (isNaN(code as number) || typeof code !== 'number' || code.toString().length !== 6) {
    verifyMsg.value = '验证码格式不正确，应该为6位数字';
    return false;
  }

  return true;
};

const verificaPsw = (password: string): boolean => {
  const pattern = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/;
  return pattern.test(password);
};

export {
  verifyMsg,
  verificaEmail,
  verificaPassword,
  confirmPassword,
  verificaPsw,
  verificaCode
};